<template>
  <div class="w-full flex flex-col p-16 sm:p-24 gap-16 flex-1">
    <div
      class="flex justify-between w-full border-b border-grey-200 pb-16 flex-1"
    >
      <TypographyBody
        class="text-grey-500 font-semibold flex-shrink-0 min-w-fit-content whitespace-nowrap flex-1"
      >
        {{ $t('health_actions.scheduling.doctor') }}
      </TypographyBody>
      <TypographyBody class="flex-1 text-right">
        {{ scheduledAppointment.providerName }}
      </TypographyBody>
    </div>
    <div
      class="flex justify-between w-full border-b border-grey-200 pb-16 flex-1"
    >
      <TypographyBody
        class="text-grey-500 font-semibold flex-shrink-0 min-w-fit-content whitespace-nowrap flex-1"
      >
        {{ $t('health_actions.scheduling.date_time') }}
      </TypographyBody>
      <TypographyBody class="text-right flex-1">
        {{ formattedDate }} {{ $t('health_actions.scheduling.at') }}
        {{ formattedTime }}
      </TypographyBody>
    </div>
    <div
      class="flex justify-between w-full border-b border-grey-200 pb-16 flex-1"
    >
      <TypographyBody
        class="text-grey-500 font-semibold flex-shrink-0 min-w-fit-content whitespace-nowrap flex-1"
      >
        {{ $t('health_actions.scheduling.facility_name') }}
      </TypographyBody>
      <TypographyBody class="text-right flex-1">
        {{ scheduledAppointment.facility }}
      </TypographyBody>
    </div>
    <div
      class="flex justify-between w-full border-b border-grey-200 pb-16 flex-1"
    >
      <TypographyBody
        class="text-grey-500 font-semibold flex-shrink-0 min-w-fit-content whitespace-nowrap flex-1"
      >
        {{ $t('common.phone') }}
      </TypographyBody>
      <TypographyBody class="text-right flex-1">
        {{ formattedPhoneNumber }}
      </TypographyBody>
    </div>
    <div
      class="flex justify-between w-full border-b border-grey-200 pb-16 flex-1"
    >
      <TypographyBody
        class="text-grey-500 font-semibold flex-shrink-0 min-w-fit-content whitespace-nowrap flex-1"
      >
        {{ $t('common.address') }}
      </TypographyBody>
      <TypographyBody class="text-right flex-1">
        {{ scheduledAppointment.address }}
      </TypographyBody>
    </div>
    <TypographyBody class="text-grey-500">
      {{ $t('health_actions.scheduling.changes_not_shown_warning') }}
    </TypographyBody>
    <!-- DE-SCOPED FROM V1 -->
    <!-- <div class="flex justify-evenly w-full h-full flex-1">
      <div class="flex items-center justify-center gap-8 flex-1">
        <CalendarAddSolid />
        <span class="font-semibold">{{
          $t('health_actions.scheduling.reschedule')
        }}</span>
      </div>
      <div class="flex min-h-full border-l border-grey-200 flex-grow-0" />
      <div class="flex items-center justify-center gap-8 flex-1">
        <CalendarCancel />
        <span class="font-semibold">{{ $t('common.cancel_btn') }}</span>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TypographyBody from '~/components/common/Typography/Body.vue'
import { formatPhoneNumber } from '@platform-shared/utils/formatters.js'
import { format, parseISO } from 'date-fns'

export default {
  components: {
    TypographyBody,
  },
  computed: {
    ...mapGetters('scheduling', ['scheduledAppointment']),
    formattedPhoneNumber() {
      return formatPhoneNumber(this.scheduledAppointment.phone)
    },
    formattedDate() {
      return format(
        parseISO(this.scheduledAppointment.appointmentTime),
        'MM/dd/yyyy'
      )
    },
    formattedTime() {
      return format(
        parseISO(this.scheduledAppointment.appointmentTime),
        'hh:mm a'
      )
    },
  },
}
</script>
